// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2k99K","unreadBadge":"styles_unreadBadge__2PZYf","modalContent":"styles_modalContent__3h4Vr","modal":"styles_modal__3nfAA"};